import { get, addLineBreaks } from "../../utils/objectHelpers";

static const baseClass = "str-text-span";

static const parseAria = (ariaHidden, accessibilityText) => {
    if (ariaHidden) return { "aria-hidden": "true" };
    if (accessibilityText.length) return { "aria-label": accessibilityText };
    return null;
}

static const parseStyles = (styles) => ([baseClass, ...styles].join(" "));

static const parseTextSpans = ({ textSpans, classes, target, spanContainers, customParser }) => {
    return (textSpans || [])
        .filter(textSpan => !!textSpan.text)
        .map((textSpan, idx, spans) => {
            const { text } = textSpan;
            const action = get(textSpan, "action", {});
            const tracking = get(action, "trackingList.0", get(action, "tracking", null));
            const trackingAttr = tracking ? { "data-track": JSON.stringify(tracking) } : null;
            const styles = get(textSpan, "styles", []).concat(classes);
            const accessibilityText = get(textSpan, "accessibilityText", "");
            const href = action.URL ? { href: action.URL } : null;
            const targetAttr = href && target ? { target: target } : null;
            const aria = parseAria(textSpan.ariaHidden, accessibilityText);
            const shouldHaveAccessibilitySpan = !href && aria && aria["aria-label"];
            let parsedText = text;
            if (customParser) {
                parsedText = customParser(text);
            }
            const spacedText = `${parsedText}${idx < spans.length - 1 ? " " : ""}`;

            if (shouldHaveAccessibilitySpan) {
                const container = "span";
                const accessibilitySpan = { container, class: "clipped", text: accessibilityText };
                const textValueSpan = { container, text: spacedText, attrs: { "aria-hidden": "true" }, class: parseStyles(styles) };

                return [accessibilitySpan, textValueSpan];
            }

            const attrs = { ...href, ...targetAttr, ...aria, ...trackingAttr };
            const needsContainer = styles.length || Object.keys(attrs).length || spanContainers;
            const container = needsContainer ? (action.URL ? "a" : spanContainers ? spanContainers : "span") : null;

            return  { attrs, container, text: spacedText, class: parseStyles(styles) };
        })
        .flat();
};

<if(input)>
    $ {
        const inputIsArray = Array.isArray(input);
        const validTextSpan = inputIsArray ? input : get(input, "textSpans", []);
        const target = inputIsArray ? null : get(input, "target", null);
        const customParser = inputIsArray ? null : get(input, "customParser", null);
        const spanContainers = inputIsArray ? null : get(input, "spanContainers", null);
        const classes = inputIsArray ? [] : get(input, "class", "").trim().split(" ").filter(Boolean);
        const textSpans = parseTextSpans({ textSpans: validTextSpan, classes, target, spanContainers, customParser });
    }

    <for|span, idx| of=textSpans>
        <${span.container} key=idx class=span.class ...span.attrs>
            <if(input.allowHtml === true)>
                $!{addLineBreaks(span.text)}
            </if>
            <else>
                ${span.text}
            </else>
        </>
    </for>
</if>
